// extracted by mini-css-extract-plugin
export default {"container":"PostBreadcrumbs-module__container--WXQ8L","animatedBackground":"PostBreadcrumbs-module__animatedBackground--DVayM"};